export default "__VITE_ASSET__iKf2_Wo$__"